var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStr2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 25,
    viewBox: "0 0 10 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.41704 13.0721C8.51005 13.1651 8.55655 13.2721 8.55655 13.393C8.55655 13.5139 8.51005 13.6209 8.41704 13.7139L1.91593 20.215C1.82292 20.308 1.71597 20.3545 1.59506 20.3545C1.47415 20.3545 1.36719 20.308 1.27419 20.215L0.576643 19.5174C0.483637 19.4244 0.437134 19.3175 0.437134 19.1966C0.437134 19.0757 0.483637 18.9687 0.576643 18.8757L6.05934 13.393L0.576643 7.9103C0.483637 7.81729 0.437134 7.71033 0.437134 7.58943C0.437134 7.46852 0.483637 7.36156 0.576643 7.26855L1.27419 6.57101C1.36719 6.478 1.47415 6.4315 1.59506 6.4315C1.71597 6.4315 1.82292 6.478 1.91593 6.57101L8.41704 13.0721Z",
    fill: "#F26522"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStr2);
export default __webpack_public_path__ + "static/media/str2.15740c371dff4aa8c63855725fa4730f.svg";
export { ForwardRef as ReactComponent };